import { getImageBase64, getThemePic } from "@/views/home/slidePPT/use/methods";
const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);
  const imgsrcList = await getImageBase64(node.title, 3);
  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "nR9HVsY6gP",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 29.14288057742782,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "7aMOtHGQL_",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 28.90100065616798,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "K-x_oM9Zyl",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 29.041748687664043,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "k0FMpMDXzQ",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 29.777477034120736,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "8csSljinQS",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 29.438484251968504,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "T-015XvyVB",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 38.80282152230971,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "at7U2SFu4N",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 38.560859580052494,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "RYpwFKyEW5",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 38.70168963254593,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "jemaBgMb4C",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 39.437417979002625,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "p0E3mpoy98",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 39.09842519685039,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "d-CWgHTGfj",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 48.4627624671916,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "lJU4o_dLp0",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 48.22080052493438,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hhTnNQZfQ1",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 48.36154855643044,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "taIUIhdxA5",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 49.09727690288714,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "LdWee_CMvX",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 48.758284120734906,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "IPcn5EbgvK",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 58.122621391076116,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "SNMW0d64NV",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 57.88074146981627,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "aKbol-RLvb",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 58.02148950131234,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_K5AaXvK-d",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 58.75721784776903,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "PZw0FT8vlF",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 58.418225065616795,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "MlV1Lp9BHa",
        width: 820.500997375328,
        height: 57.5,
        left: 89.74950131233598,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 25px;"><span style="font-family: Microsoft Yahei;"><span>${node.title || ""
          }</span></span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "shape",
        id: "Xxt-2ZunYu",
        width: 747.4028871391076,
        height: 142.08587598425197,
        left: 0,
        top: 97.25836614173228,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "xd0lTKaZ_x",
        width: 646.0770997375328,
        height: 81.59375,
        left: 37.31651902887139,
        top: 126.00442913385827,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="color: #FFFFFF;font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[0].title || ""
          }${node.children[0].title ? "：" : ""}${node.children[0].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "shape",
        id: "oOGDEjzpLF",
        width: 747.4028871391076,
        height: 142.08587598425197,
        left: 252.5971128608924,
        top: 239.34424212598424,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}94`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "4UH1eN2vkz",
        width: 747.4028871391076,
        height: 142.08587598425197,
        left: 0,
        top: 381.4301181102362,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "FlgIHMsFQ1",
        width: 646.0770997375328,
        height: 81.59375,
        left: 311.54675196850394,
        top: 268.0903051181102,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="color: #FFFFFF;font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[1].title || ""
          }${node.children[1].title ? "：" : ""}${node.children[1].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "text",
        id: "3roUji6PbZ",
        width: 646.0770997375328,
        height: 81.59375,
        left: 47.16609251968504,
        top: 410.1761811023622,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="color: #FFFFFF;font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[2].title || ""
          }${node.children[2].title ? "：" : ""}${node.children[2].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "image",
        id: "AfFvQyJDE4",
        src: imgsrcList[0],
        width: 252.5971128608924,
        height: 142.08587598425197,
        left: 747.4028871391076,
        top: 97.25836614173228,
        fixedRatio: true,
        rotate: 0,
      },
      {
        type: "image",
        id: "f_SgcWQar0",
        src: imgsrcList[1],
        width: 252.5971128608924,
        height: 142.08587598425197,
        left: 0,
        top: 239.34424212598424,
        fixedRatio: true,
        rotate: 0,
      },
      {
        type: "image",
        id: "4J4nJxrfSv",
        src: imgsrcList[2],
        width: 252.5971128608924,
        height: 142.08587598425197,
        left: 747.4028871391076,
        top: 381.4301181102362,
        fixedRatio: true,
        rotate: 0,
      },
    ],
    background: {
      type: "solid",
      color: "#fff",
    },
  };
};

export default nodule;
